import {ApiCourseProduct} from "../../model/rest/rest-model";

export class LangProductMapper {
    static langCodes = ['en', 'sp', 'en.bs', 'en.ch'];
    static langCodeName = ['English', 'Spanish', 'Business English', 'English For Children'];
    // casa Course enum names (parallel to langCodes) — used to identify a course in casa
    // course-profile endpoints, which resolve the course by its enum name, not by the product code.
    static courseEnumCodes = ['en', 'es', 'enBs', 'enKids'];
    static iconImages = ['/assets/img/english%20icon.png', '/assets/img/spanish%20icon.png', '/assets/img/business.png', ''];
    static activeLangCodes = [LangProductMapper.langCodes[0], LangProductMapper.langCodes[1], LangProductMapper.langCodes[2], LangProductMapper.langCodes[3]];
    private static cspaLangCodes = ['english' , 'spanish'];
    private static cspaNewLangCodes = [ 'en', 'sp', 'enbus', 'encfk'];

    public static mapLangCodeToCourseEnumCode(langCode: string): string {
        const idx = this.langCodes.indexOf(langCode);
        return idx >= 0 ? this.courseEnumCodes[idx] : langCode;
    }

    public static mapCourseEnumCodeToLangCode(courseEnumCode: string): string {
        const idx = this.courseEnumCodes.indexOf(courseEnumCode);
        return idx >= 0 ? this.langCodes[idx] : courseEnumCode;
    }

    public static getCourseProducts(): ApiCourseProduct[] {
        const res: ApiCourseProduct[] = [];
        for (let i = 0 ; i < this.langCodes.length ; i++) {
            const prod = new ApiCourseProduct();
            prod.code = this.langCodes[i];
            prod.name = this.langCodeName[i];
            res.push(prod);
        }
        return res;
    }

    public static mapLangCodeToLangName(lang: string): string {
        return this.langCodeName[this.langCodes.indexOf(lang)];
    }
}
